import React from 'react';
import AgentInfo from '../messages/agent_widget';
import '../shipment/shipment.less';
import { browserHistory } from 'react-router';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

class ShipmentDetailsSection extends React.Component{
  constructor(props){
    super(props);
    const shipments = this.props.shipment.shipmentDetails;
    this.state ={
      shipments
    }
  }
  componentWillReceiveProps(newProps){
    // this.setState({shipments: })
  }

  render(){
    const {props,state} = this;
    return(
      <div>
      { this.props.shipment.shipmentDetails &&
          <AgentInfo  shipment = {props.shipment.shipmentDetails} shipmentId={this.props.shipmentId} backTo={'browse'} />}
      </div>
    )
  }
}

ShipmentDetailsSection = connect((state) => {
  return {
    shipment: state.app.shipment
  }
}, (dispatch) => {
  return {

  }
})(ShipmentDetailsSection);

export default ShipmentDetailsSection;



// WEBPACK FOOTER //
// app/browse_packages/shipment_details_section.jsx